import { render, staticRenderFns } from "./AutoAssign.vue?vue&type=template&id=0381854c&scoped=true&lang=pug"
import script from "./AutoAssign.vue?vue&type=script&lang=ts"
export * from "./AutoAssign.vue?vue&type=script&lang=ts"
import style0 from "./AutoAssign.vue?vue&type=style&index=0&id=0381854c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0381854c",
  null
  
)

export default component.exports